import React, { useState } from 'react';
import { TextInput, TouchableOpacity } from 'react-native';
import { Color, CommonProperties } from '../../../styles';
import RowView from '../../RowView';
import Icon from '../../Icon';
import { scale } from '../../../utils/scale.utils';
import { useTranslation } from 'react-i18next';
import { i18nNS, useComponentTKey } from '../../../i18n';

const ChatInput = ({ onSubmit }) => {
  const { t } = useTranslation(i18nNS.tripHub);
  const { tKey } = useComponentTKey('TripHubScreen');
  const [message, setMessage] = useState('');

  const onEnter = () => {
    onSubmit(message);
    setMessage('');
  };

  return (
    <RowView
      style={{
        backgroundColor: Color.primary,
        ...CommonProperties.p3,
        ...CommonProperties.centerItems,
      }}
    >
      <TouchableOpacity
        onPress={() => {
          console.log('open camera ');
        }}
      >
        <Icon name="camera" size={24} color="white" />
      </TouchableOpacity>
      <TextInput
        style={{
          flex: 1,
          backgroundColor: 'white',
          ...CommonProperties.py2,
          ...CommonProperties.px3,
          ...CommonProperties.mx3,
          ...CommonProperties.fontFamily,
          ...CommonProperties.body,
          ...CommonProperties.borderRadius2,
          borderWidth: 1,
          borderColor: '#cccccc',
          maxHeight: scale(80),
        }}
        placeholder={t(tKey('Message'))}
        value={message}
        multiline
        onChangeText={(text) => setMessage(text)}
        onSubmitEditing={onEnter}
      />
      <TouchableOpacity
        onPress={() => {
          if (message.length > 0) {
            onEnter();
          } else {
            // TODO: open images
          }
        }}
      >
        <Icon name={message.length > 0 ? 'circleRight' : 'circleUp'} size={24} color="white" />
      </TouchableOpacity>
    </RowView>
  );
};

export default ChatInput;
